import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";


export async function postTicketComment(payload) {
  try {
    const data = await authenticatedFetch(URL.postTicketComment, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return data;
  } catch (error) {
    console.error("Error executing ticket comment:", error);
    throw error;
  }
}
